import React, { useState } from 'react';
import axios from "axios";
import TextField from '@material-ui/core/TextField';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';

import { Auth } from 'aws-amplify';

import {
    FormBlock,
    FormTitle,
    HalfBlock,
} from "../../generalStyles/mixin";

import * as env from "../../environment";

const { API_URL_BACKEND } = env[process.env.NODE_ENV];

const useStyles = makeStyles((theme) => ({
    button: {
        display: 'block',
        marginTop: theme.spacing(2),
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
}));

function MessengerComponent() {

    const [registros, setRegistros] = useState([])
    const [valorFiltro, setValorFiltro] = useState("")
    const [filtro, setFiltro] = useState("")
    const [loading, setLoading] = useState(false)

    const classes = useStyles();

    const buscaPorBusinessID = async () => {
        const filtro = 'mtd_business_id'
        setFiltro(filtro)
        buscaPorFiltro(filtro)
    }

    const buscaPorFiltro = async (filtro) => {
        setLoading(true)
        const request1 = {
            filtro: filtro,
            valor: valorFiltro
        }
        console.log("Actualizamos : " + JSON.stringify(request1))
        const endpoint = `${API_URL_BACKEND}/outbox/busca`

        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            }
        };

        try {
            const response1 = await axios.post(endpoint, request1, config)

            if (response1.status === 200) {
                console.log("Respuesta", response1)

                const registros = []
                for(const unRegistro of response1.data.datos) {
                    registros.push(unRegistro)
                }
                setRegistros(registros)
            } else {
                alert("Error " + response1.status + " : " + response1.message)
            }
        } catch (e) {
            alert("No se pudo buscar")
            console.error("No se pudo buscar", e)
        }
        setLoading(false)
    }

    const dejarPendiente = async (id) => {
        setLoading(true)
        const request1 = {
            id: id
        }
        console.log("Actualizamos : " + JSON.stringify(request1))
        const endpoint = `${API_URL_BACKEND}/outbox/pendiente`

        await refreshToken();

        const config = {
            headers: { 
                Authorization: `Bearer ${localStorage.getItem('token')}`,
                AuditUser: `${localStorage.getItem('user')}`
            }
        };

        try {
            const response1 = await axios.post(endpoint, request1, config)

            if (response1.status === 200) {
                console.log("Respuesta", response1)
                buscaPorFiltro(filtro)
            } else {
                alert("Error " + response1.status + " : " + response1.message)
                setLoading(false)
            }
        } catch (e) {
            setLoading(false)
            alert("No se pudo modificar")
            console.error("No se pudo modificar", e)
        }
    }

    const refreshToken = async () => {
            try {
              const cognitoUser = await Auth.currentAuthenticatedUser();
              const { refreshToken } = cognitoUser.getSignInUserSession();
              cognitoUser.refreshSession(refreshToken, (err, session) => {
                const { accessToken } = session;
                localStorage.setItem("token", accessToken.jwtToken);
              });
            } catch (e) {
              localStorage.clear();
              window.location = '/';
            }
          };

    return (<>
        <FormBlock>
            <FormTitle>Envios de correos</FormTitle>

            <HalfBlock>
                <FormControl className={classes.formControl}>

                    <TextField
                                        placeholder=""
                                        type="text"
                                        label="Business ID"
                                        inputProps={{ maxLength: 50 }}
                                        value={valorFiltro}
                                        onChange={(ev) => {
                                            setValorFiltro(ev.target.value );
                                        }}
                                    />

                    <div class="loader-box">
                    {loading && <div class="loader"></div>}
                    </div>
                </FormControl>

                <DialogActions>
                    <Button onClick={buscaPorBusinessID} color="primary">
                        Buscar
                    </Button>
                </DialogActions>
            </HalfBlock>
        </FormBlock>

        {registros.length > 0 && <>
            <br/>
                <FormBlock>
                    <table>
                        <thead>
                            <tr>
                                <th>id</th>
                                <th>mtdBusinessId</th>
                                <th>mtdProcessId</th>
                                <th>cuenta</th>
                                <th>numeroDoc</th>
                                <th>fecha creacion</th>
                                <th>fecha inicio</th>
                                <th>estado</th>
                                <th>fecha estado</th>
                                <th>correo</th>
                                <th>obs</th>
                                <th>accion</th>
                                
                                
                            </tr>
                        </thead>
                        <tbody>
                            
                            {registros.map(row => (
                                <tr key={row.id}>
                                    <td>{row.id}</td>
                                    <td>{row.mtdBusinessId}</td>
                                    <td>{row.mtdProcessId}</td>
                                    <td>{row.cuenta}</td>
                                    <td>{row.numeroDoc}</td>
                                    <td>{row.fecha_creacion ? new Date(row.fecha_creacion).toLocaleString("es-CL") : ''}</td>
                                    <td>{row.fecha_inicio ? new Date(row.fecha_inicio).toLocaleString("es-CL") : ''}</td>
                                    <td>{row.estado}</td>
                                    <td>{row.fecha_estado ? new Date(row.fecha_estado).toLocaleString("es-CL") : ''}
                                    </td>
                                    <td>{row.toAddress}</td>
                                    <td>{row.glosa}</td>
                                    <td>
                                        <Button disabled={"PENDIENTE" === row.estado} onClick={() => dejarPendiente(row.id)} color="primary">
                                            Dejar pendiente
                                        </Button>
                                    </td>
                                    
                                    
                                    
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </FormBlock>
            <br/>
        </>}
    </>
    )
}

export default MessengerComponent;